import { styled } from 'styled-components';

import { fontSizes, spacing } from '#/theme/theme';

export const SearchVolopHitOrgLinkHolder = styled.div`
  padding-top: ${spacing[8]};
  margin-bottom: ${spacing[8]};
  font-size: ${fontSizes[12]};
`;
